import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import BlurModal from '../../../../src/components/common/blur-modal';
import { NotificationWarning } from '@dbk/ui-icons';
import '../../../../src/assets/styles/hrmw-mcd.scss';
import message from '@dbk/ui-forms/src/message/message';

class DuplicateContactModal extends Component {
	constructor(props) {
		super(props);
		this.state=({showDuplicateModal: true});
	}

	closeModal = () => {
		this.props.onCloseDuplicateModal();
	}

	render() {
		const { i18n: { messages }, hrmw: {latestContactDetails}, dupIndex } = this.props;
		let dupRecord = latestContactDetails[dupIndex];
		let dupData = dupRecord.emailId ? dupRecord.emailId : dupRecord.phone ? `+${dupRecord.phone.countryCode} ${dupRecord.phone.phoneNo}` : `+${dupRecord.fax.countryCode} ${dupRecord.fax.phoneNo}`;
		return (
			<div>
				<BlurModal
					visible={true}
					title={messages['app.manageContactDetails.duplicateValue']}
					onDone={this.closeModal}
					size={'large'}
					headerVisible={false}
        		>
					<div className="error-message-container">
						<NotificationWarning color='#b92635' className="error-icon" width={25} height={25} />
						<span className="error-message-content">
							{messages['app.manageContactDetails.contactDetailsExistFor']} "{dupData}"
							</span>
					</div>
				</BlurModal>
			</div>
		)
	}
}

export default createContainer({
	$queries: {
		i18n: {
			messages: true,
		},
		hrmw: {
			latestContactDetails: true
		}
	}
})(DuplicateContactModal);